import { schema } from "normalizr";
import { CollectionPOI as CollectionPOIRecord } from "records/collection";

export const CollectionPOI = new schema.Entity(
    "collectionPOIs",
    {},
    {
        idAttribute: (value) => value.poi_id,
    },
);

(CollectionPOI as any).record = CollectionPOIRecord;
